import React, {useEffect, useState, useRef} from "react";
import {useParams} from "react-router-dom";
import axiApi from "ApiCaller";
import NavBreadcrum from "components/NavBreadcrum";
import {useTranslation} from "react-i18next";
import moment from "moment";
import ButtonsActions from "views/utils/buttonsActions";
import {useNavigate} from "react-router-dom";
import TopBarActions from "components/TopBarActions";
import navs from "../../navs";
import Spinner from "components/loaders/spinner";
import IconBool from "components/IconBool";

const buttonsActions = new ButtonsActions();

const PluginList = () => {
    const {token} = useParams();
    const [listImports, setListImports] = useState([]);
    const {t: _Tr} = useTranslation("routes");
    const navigate = useNavigate();
    const [buttonsTB, setButtonsTB] = useState(buttonsActions);
    const items = useRef({
        showed: [],
        chosen: [],
    });
    const [itemsShow, setItemsShow] = useState([]);
    const [loading, setLoading] = useState(true);

    const bread = [
        {name: _Tr("labels.administration"), url: "/administration", current: false},
        {
            name: _Tr("labels.plugins"),
            url: `/administration/plugins/`,
            current: false,
        },
        {
            name: _Tr("labels.plugin"),
            // url: `/administration/plugins/list/${token}/`,
            current: true,
        },
        // {name: _Tr("labels.plugins"), current: true},
    ];

    const onClickEdit = () => {
        if (items.current.chosen.length !== 1) {
            return false;
        }
        let idx = parseInt(items.current.chosen[0]);
        let token = items.current.showed[idx].token;
        // console.log(token);
        navigate(`/administration/plugins/edit/${token}/`);
    };

    const clickRow = (e) => {
        let idx, checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector("input[type='checkbox']");
        }
        idx = parseInt(checkbox.value);
        let buttons = {...buttonsTB};

        if (items.current.chosen.includes(idx)) {
            items.current.chosen = items.current.chosen.filter((e) => e !== idx);
            checkbox.checked = false;
        } else {
            items.current.chosen.push(idx);
            checkbox.checked = true;
        }
        buttons.delete.disabled = !(items.current.chosen.length > 0);

        if (items.current.chosen.length === 1) {
            buttons.edit.disabled = false;
        } else {
            buttons.edit.disabled = true;
        }
        setButtonsTB(buttons);
    };

    useEffect(() => {
        let title = _Tr("labels.importations");
        document.title = title;
        let buttons = {...buttonsTB};
        buttons.title = title;
        buttons.edit.active = true;
        buttons.edit.onClick = onClickEdit;
        buttons.edit.disabled = true;

        axiApi
            .get(`/api/plugins/inventory/imports/list/${token}/`)
            .then((resp) => {
                setListImports(resp.data.imports);
                items.current.showed = resp.data.imports;
                setItemsShow(resp.data.imports);
                buttons.counter = resp.data.imports.length;
                setButtonsTB(buttons);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [token]);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} />
            <div>
                {/* <h1>Lista de Importaciones del Plugin</h1>
                <p>Token del plugin: {token}</p> */}
                {loading ? (
                    <Spinner />
                ) : listImports.length === 0 ? (
                    <p className="alert alert-info">
                        No hay importaciones para mostrar para este plugin.
                    </p>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th key="-1">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="all"
                                        />
                                    </th>
                                    <th>Creada</th>
                                    <th>Email</th>
                                    <th>Verificada</th>
                                    <th>Importada</th>
                                    <th>Finalizada</th>
                                    <th>Avisos</th>
                                    <th>Error</th>
                                    <th>Tamaño</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsShow.map((item, index) => (
                                    <tr
                                        key={item.token}
                                        onClick={clickRow}
                                        style={{cursor: "pointer"}}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                value={index}
                                                checked={items.current.chosen.includes(
                                                    index
                                                )}
                                                onChange={(e) => {
                                                    clickRow(e);
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {moment(item.created).format(
                                                "DD/MM/YYYY HH:mm"
                                            )}
                                        </td>
                                        <td>{item.email}</td>
                                        {/* <td>{item.verified ? "Sí" : "No"}</td> */}
                                        <td>
                                            <IconBool value={item.verified} />
                                        </td>
                                        {/* <td>{item.imported ? "Sí" : "No"}</td> */}
                                        <td>
                                            <IconBool value={item.imported} />
                                        </td>
                                        <td>
                                            {item.ended
                                                ? moment(item.ended).format(
                                                      "DD/MM/YYYY HH:mm"
                                                  )
                                                : ""}
                                        </td>
                                        <td>
                                            {item.result &&
                                            item.result.warnings !== undefined
                                                ? item.result.warnings
                                                : ""}
                                        </td>
                                        <td>
                                            {item.result && item.result.error
                                                ? item.result.error
                                                : ""}
                                        </td>
                                        <td>{item.size}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    );
};

export default PluginList;
